import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { isLoggedIn, login } from '../auth/oidc';
import { isOidcConfigured } from '../config';
import Button from '../components/Button';

type LocationState = { from?: { pathname?: string } } | null;

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn()) {
      const state = location.state as LocationState;
      const to = state?.from?.pathname ?? '/';
      navigate(to, { replace: true });
    }
  }, [navigate, location]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <h2 className="text-large font-bold">Appsteam Website CMS</h2>
      {isOidcConfigured ? (
        <>
          <Button theme="primary" onClick={() => login()}>
            Swisscom Login
          </Button>
          <p>Stelle sicher, dass du die benötigte Rolle hast.</p>
        </>
      ) : (
        <p>Login ist noch nicht konfiguriert.</p>
      )}
    </div>
  );
}
